import React, { useState } from "react";
import { Avatar } from "@mui/material";
import getUrlqueries from "../../../../Utils/getUrlqueries";
import { useNavigate } from "react-router-dom";

const returnDate = (d) => {
  return new Date(d).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

const ProfileViews = ({ activity }) => {
  const [status, setstatus] = useState("All");
  const userid = getUrlqueries("userid");
  const navigate = useNavigate();
  return (
    <>
      {activity ? (
        <>
          <div className="">
            <select
              id="typeDropdown"
              className="h-40px"
              value={status}
              onChange={(e) => setstatus(e.target.value)}
            >
              <option value="All">All</option>
              <option value="others">Viewed by others</option>
              <option value="this">Viewed by this user</option>
            </select>
            (
            {
              activity.filter((lead) => {
                if (status === "All") return lead;
                else if (lead.senderid?._id === userid && status === "this")
                  return lead;
                else if (lead.receiverid?._id === userid && status === "others")
                  return lead;
              }).length
            }
            )
          </div>
          <table className="plan_table mt-24">
            <thead className="plan_thead activityplan_thead">
              <tr>
                <th>Profile</th>
                <th>Viewed by</th>
                <th>Date</th>
              </tr>
            </thead>
            {activity.length > 0 &&
              activity
                .filter((lead) => {
                  if (status === "All") return lead;
                  else if (lead.senderid?._id === userid && status === "this")
                    return lead;
                  else if (
                    lead.receiverid?._id === userid &&
                    status === "others"
                  )
                    return lead;
                })
                .map((res, i) => {
                  if (
                    res.senderid &&
                    res.senderid?.name &&
                    res.receiverid &&
                    res.receiverid?.name
                  )
                    return (
                      <tr key={i} className="my-2 pt-2">
                        <td
                          onClick={() =>
                            navigate(
                              `/admin/user-activity?tab=13&userid=${res.receiverid?._id}`
                            )
                          }
                          className="pointer my-2 pt-2"
                        >
                          <Avatar
                            src={res.receiverid ? res.receiverid.avatar : ""}
                          />
                          {res.receiverid ? `${res.receiverid.name} ` : ""}
                        </td>
                        <td
                          onClick={() =>
                            navigate(
                              `/admin/user-activity?tab=13&userid=${res.senderid?._id}`
                            )
                          }
                          className="pointer my-2 pt-2"
                        >
                          <Avatar
                            src={res.senderid ? res.senderid.avatar : ""}
                          />
                          {res.senderid ? `${res.senderid.name} ` : ""}
                        </td>
                        <td className=" my-2 pt-2">
                          {returnDate(res.createdAt)}
                        </td>
                      </tr>
                    );
                })}
          </table>
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default ProfileViews;
